import React, { Component } from "react";
import { connect } from "react-redux";
import InfoIcon from "../../../../../assets/img/assessmentLearnImages/infoIcon.svg";
import { Button } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { readAssessment } from "../../../../../store/actions/assessment.action";
import { withTranslation } from "react-i18next";

import moment from "moment";

import classes from "./EvaluationPending.module.css";
class EvaluationPending extends Component {
  async componentWillMount() {
    const assessmentId = localStorage.getItem("_assessmentId");
    await this.props.readAssessment(assessmentId);
  }
  goToAssessmentsHandler = () => {
    if(this.props.isWebView){
    this.props.history.push("/assessment-list-webview");
    }else {
      this.props.history.push("/dashboard/assessments"); 
    }
  };
  render() {
    const { t } = this.props;
    return (
      <>
        <div className={classes.MainBody}>
          {/* Header */}
          <div>
          {this.props.isKtvAssessment ? ( <div> </div>) : (<Button
              className={classes.CloseBtn}
              variant="contained"
              onClick={this.goToAssessmentsHandler}
              autoFocus
            >
              <CloseIcon />
          </Button>)  }
          </div>
          {/* Body */}
          <div className={classes.Body}>
            <p
              className="TextMediumGrey"
              style={{ fontSize: "20px", fontWeight: "600" }}
            >
              {this.props.assessmentData.name}
            </p>
            <div className={classes.AssessmentDetailsContainer}>
              <div>
                <span className="TextMediumGrey" style={{ fontWeight: "600" }}>
                  {t("Total Score")}:{" "}
                </span>
                <span className="TextMediumGrey">
                  {this.props.assessmentData.totalScore}
                </span>
              </div>
              <div>
                <span className="TextMediumGrey" style={{ fontWeight: "600" }}>
                  {t("Published On")}:{" "}
                </span>
                <span className="TextMediumGrey">
                  {this.props.assessmentData.publishedOn
                    ? moment(this.props.assessmentData.publishedOn).format(
                        "MMM Do, h:mm a",
                      )
                    : t("No Published Date")}
                </span>
              </div>
              <div>
                <span className="TextMediumGrey" style={{ fontWeight: "600" }}>
                  {t("Due On")}:{" "}
                </span>
                <span className="TextMediumGrey">
                  {this.props.assessmentData.setting.dueOn
                    ? moment(this.props.assessmentData.setting.dueOn).format(
                        "MMM Do, h:mm a",
                      )
                    : t("No Due Date")}
                </span>
              </div>
            </div>
            <div className={classes.AssessmentDetailsContainer}>
              <div>
                <img src={InfoIcon} style={{ margin: "0" }} alt="ic_img" />
                <span className="TextMediumGrey" style={{ marginLeft: "10px" }}>
                  {t("Evaluation Pending")}
                </span>
              </div>
            </div>
          </div>
          {/* Footer */}
          <div className={classes.Footer}>
          {this.props.isKtvAssessment ? ( <div> </div>) : ( <Button
              className={classes.SeeSolutionBtn}
              variant="contained"
              autoFocus
              onClick={this.goToAssessmentsHandler}
            >
              {t("Done")}
            </Button>)}
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    assessmentData: state.assessmentsReducer.assessmentdata,
    isWebView : state.assessmentsReducer.isWebView,
    isKtvAssessment : state.assessmentsReducer.isKtvAssessment
  };
};

export default connect(mapStateToProps, { readAssessment })(
  withTranslation()(EvaluationPending),
);
